angular.module(ApplicationConfiguration.applicationModuleName).directive("filterForm", function ($sessionStorage, permissionService, Reports, MessageService, ColorRequest, FileSaver, settings, $state) {
    return {
        restrict: "E",
        scope: {
            onSubmit: "&",
            states: "=",
            managers: "=",
            status: "=",
            useAllFilters: "="
        },
        templateUrl: "/modules/Commom/core/views/filter.form.html",
        controller: function ($scope) {

            $scope.isDesigner = function () { return settings.isColorsUserGroupByName('Designer'); }
            $scope.isGerenteRegional = function () { return settings.isColorsUserGroupByName('GerenteRegional'); }
            $scope.isControleQualidade = function () { return settings.isColorsUserGroupByName('ControleQualidade'); }
            $scope.isGerenteNacional = function () { return settings.isColorsUserGroupByName('GerenteNacional'); }

            $scope.getFilters = function () {
                $scope.filter = $sessionStorage.colorsRequestsContextFilter;
                $scope.filterCustomer = $sessionStorage.colorsRequestsContextFilter_Customer || null;

                if (!$scope.filter) {
                    var todayDate = new Date(Date.now());
                    var lastYear = new Date(todayDate.getFullYear() - 1, 0, 1);
                    $scope.filter = {
                        startsOn: lastYear,
                        endsOn: todayDate,
                        expired: false,
                    };

                    if ($scope.statusId) $scope.filter.statusId = $scope.statusId;
                    if ($scope.stateId) $scope.filter.stateId = $scope.stateId;
                    if ($scope.designerName) $scope.filter.designerName = $scope.designerName;
                    if ($scope.userName) $scope.filter.userName = $scope.userName;
                    if ($scope.code) $scope.filter.code = $scope.code;
                    if ($scope.managerId) $scope.filter.managerId = $scope.managerId;
                }

                $scope.filter.colorsRequestId = null;

                if (!$scope.useAllFilters) {
                    $scope.filter.userName = null;
                    $scope.filter.customerName = null;
                    $scope.filter.code = null;
                    $scope.filter.expired = null;
                    $scope.filter.hasApprovalPedingSalesOnly = null;
                }

                $scope.filter.customerId = null;
                if ($scope.filterCustomer) $scope.filter.customerId = $scope.filterCustomer.key;

                $sessionStorage.colorsRequestsContextFilter = $scope.filter;
            };

            $scope.getFilters();

            // Função de envio do formulário
            $scope.submit = function () {
                $scope.onSubmit({ filter: $scope.filter });
            };

            $scope.$watch("filterCustomer", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $sessionStorage.colorsRequestsContextFilter_Customer = newValue;
                }
            });

            // Função para exportar para Excel
            $scope.excel = function () {
                Reports.colorRequestExcel($scope.filter,
                    function (response) {
                        var filename = moment().format("YYYYMMDDHHmmss") + "_Projetos.xlsx";
                        FileSaver.saveAs(response.data, filename);
                    },
                    function (response) {
                        var msg = $translate("errors.couldNotCompleteRequest");
                        MessageService.alertError(msg);
                    }
                );
            };

            $scope.showConsumer = function () {
                // Para Designers:
                // Não aparece os Consumidores
                if ($scope.isDesigner()) {
                    return false;
                }
                return true;
            };

            $scope.showManagementVisibleOnlyFields = function () {
                return (
                    $scope.isGerenteRegional() ||
                    $scope.isControleQualidade() ||
                    $scope.isGerenteNacional()
                )
            };

            $scope.showManagerColumn = function () {
                return $scope.isControleQualidade();
            };

            $scope.showRequesterColumn = function () {
                return $scope.isControleQualidade();
            };

            $scope.getCustomer = function (val) {
                return ColorRequest.listCustomersIds({ keyword: val }).$promise;
            };

            $scope.submit();
        },
    };
});
